export default {
  title: 'Do que estamos falando',
  image: require('@/assets/images/post/hero-doqueestamosfalando.jpg'),
  credits: 'Crédito Apu Gomes/Oxfam Brasil',
  subtitle: 'Nosso sistema tributário contribui para o aumento das desigualdades.',
  content: [
    {
      type: 'text',
      data: `
        <p>Nossa Constituição determina que o sistema tributário brasileira seja justo, cobrando mais de quem ganha mais. No entanto, o que temos hoje é um sistema que pesa muito sobre os mais pobres. </p>
        <p>Isso acontece porque nossa tributação recai mais sobre o consumo, e não sobre a renda e patrimônio. E por que isso não é justo? </p>
        <p>Na hora de comprar na padaria ou na loja de roupas, pobres e ricos pagam os mesmos impostos, independentemente de quem ganha mais ou menos. Já nos impostos cobrados sobre renda e patrimônio, a lógica é outra. Enquanto um trabalhador tem desconto direto na sua fonte de renda, os muito ricos contam com isenções e mecanismos que podem reduzir drasticamente o quanto pagam efetivamente de impostos.</p>
        <p>Não estamos falando em aumentar a carga tributária do país, queremos apenas uma redistribuição dessa carga, para que fique equilibrada em bases mais justas. Todos saem ganhando porque reduzir as desigualdades é fundamental para o desenvolvimento sustentável do país.</p>
      `,
    },
    {
      type: 'quote',
      data: {
        title: 'Impostos são o preço que se paga por uma sociedade civilizada',
        credit: 'OLIVER WENDELL HOLMES, JURISTA AMERICANO',
        highlight: require('@/assets/images/post/destaque-rosa.jpg'),
      },
    },
    {
      type: 'video',
      data: 'https://www.youtube.com/embed/ifV5bG5dsUM?modestbranding=1&autohide=1&showinfo=0&controls=0',
    },
    {
      type: 'text',
      data: `
        <p>Um sistema justo de cobrança de impostos, que seja transparente, equilibrado e com mecanismos que combatam a corrupção, promovem a expansão do alcance de políticas públicas, em especial das sociais, e combatem a pobreza extrema.</p>
        <p>Quando pagamos um imposto, estamos fazendo a nossa parte para que o governo possa oferecer os serviços públicos essenciais a toda população – especialmente às pessoas mais vulneráveis, aquelas em situação de pobreza.</p>
        <p>Para isso acontecer, é preciso também que o sistema tributário seja mais transparente, eficiente e livre de corrupção. Como contribuintes, temos o direito e o dever de cobrar isso.</p>
      `,
    },
  ],
};
